<app-desktop *ngIf="isDesktopDevice"></app-desktop>

<app-mobile *ngIf="!isDesktopDevice"></app-mobile>
